import { defineStore } from "pinia";


interface CartItem {
    id: number;
    quantity: number;
    img_product: string[];
    description_product_custom: string;
    name_product: string;
    price_product: number;
}

export const useCartShoppingStore = defineStore('cartshopping', {
    state: () => {
        return {
            cart: [] as CartItem[],
            total: 0,
            count: 0
        }
    },
    getters: {},
    actions: {
        addToCart(product: Omit<CartItem, 'quantity'>, quantity: number = 1) {
            this.$state.cart.push({ ...product, quantity: quantity });
        },
        removeFromCart(index: number) {
            const newData = this.$state.cart.filter((item) => {
                return item.id != index;
            })
            this.$state.cart = newData;
        },
    }
})